import React, { PureComponent } from 'react'
import { DsBox } from '@am92/react-design-system'

import withPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import DownloadSection from './Components/DownloadSection'
import Features from './Components/Features'
import HighlightSection from './Components/HighlightSection'
import PageIntro from './Components/PageIntro'
import PageWrapper from '~/src/Components/PageWrapper'

import LANDING_PAGE_CONSTANTS from './Landing.PageConstants'
import { T_LANDING_PAGE_CONSTANTS } from './Landing.PageConstants/TYPES'

export interface ILandingPageProps
  extends IWithPageConstantsProps<T_LANDING_PAGE_CONSTANTS> {}

class LandingPage extends PureComponent<ILandingPageProps> {
  render() {
    const { PAGE_CONSTANTS } = this.props
    return (
      <PageWrapper
        spacing={{
          xs: 'var(--ds-spacing-hot)',
          md: 'var(--ds-spacing-hot)'
        }}
        sx={{ px: undefined }}
      >
        <PageIntro PAGE_CONSTANTS={PAGE_CONSTANTS} />
        <DsBox
          sx={{
            borderTop: '1px solid var(--ds-colour-stateDisabledSurface)',
            paddingTop: {
              xs: 'var(--ds-spacing-mild)',
              md: 'var(--ds-spacing-hot)'
            }
          }}
        >
          <Features PAGE_CONSTANTS={PAGE_CONSTANTS} />
        </DsBox>
        <HighlightSection PAGE_CONSTANTS={PAGE_CONSTANTS} />
        <DownloadSection PAGE_CONSTANTS={PAGE_CONSTANTS} />
      </PageWrapper>
    )
  }
}

export default withPageConstants<T_LANDING_PAGE_CONSTANTS>(
  LANDING_PAGE_CONSTANTS
)(LandingPage)
